// Open WhatsApp robustly — handles iframe sandbox / popup blockers.
// Order: tries window.open new tab → window.top.location → window.location.
export const WA_PHONE = "918129387138";
export const WA_PHONE_DISPLAY = "+91 81293 87138";

export function buildWhatsappUrl(text = "Hi, I'm interested in the MP & OF course.") {
  const u = new URL("https://wa.me/" + WA_PHONE);
  u.searchParams.set("text", text);
  return u.toString();
}

export function openWhatsapp(text) {
  const url = buildWhatsappUrl(text);
  try {
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (w && !w.closed) return true;
  } catch (_) {}
  // Iframe blocked target=_blank — escape to top frame
  try {
    if (window.top && window.top !== window) {
      window.top.location.href = url;
      return true;
    }
  } catch (_) {}
  try {
    window.location.href = url;
    return true;
  } catch (_) {}
  return false;
}
